import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { PRODUCT } from '../data/constants';
export function SystemSection() {
  return <section className="bg-ice py-5 sm:py-7" data-id="element-168" data-mp="3biwp78cfpoea">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-169" data-mp="3bhllt9mwiinp">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-170" data-mp="36jsdob21feks">
          LE SYSTÈME VISUEL <span className="text-tech" data-id="element-171" data-mp="31kgwj0xre72o">COMPLET 6 EN 1</span>
        </h2>
        <p className="mt-1.5 text-center font-display text-sm font-semibold uppercase tracking-wide text-tech sm:text-lg" data-id="element-172" data-mp="31mtng3lhvrrv">
          Ce qui est inclus
        </p>

        <div className="mx-auto mt-3 max-w-4xl rounded-xl border-2 border-navy bg-white p-3 text-center shadow-sm sm:p-5" data-id="element-173" data-mp="2stglyd9d7hu6">
          <p className="font-heading text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-174" data-mp="2nv5e282mrhel">
            🫀 {PRODUCT}
          </p>
          <p className="mt-1.5 text-sm leading-snug text-steel sm:text-base" data-id="element-175" data-mp="2dumkump6eok0">
            Le système visuel complet pour comprendre, analyser et interpréter les
            électrocardiogrammes : fondamentaux, lecture systématique, arythmies, ischémie,
            surveillance et cas cliniques, avec tracés annotés, planches normal / anormal, fiches
            pratiques et cas pédagogiques corrigés.
          </p>
          <p className="mx-auto mt-2 w-fit max-w-full rounded-lg bg-navy px-3 py-1 font-display text-2xs font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-176" data-mp="yzbqt2ge4h6o">
            FRÉQUENCE › <span className="text-tech-light" data-id="element-177" data-mp="1roiq43no5asz">RYTHME</span> › AXE ›{' '}
            <span className="text-tech-light" data-id="element-178" data-mp="1rmps1cr4fywl">INTERVALLES</span> ›{' '}
            <span className="text-alert" data-id="element-179" data-mp="1cr04vba79fqa">ST-T</span>
          </p>
        </div>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-180" data-mp="1hpl69e16u5gb">
          {modules.map(module => <article key={module.title} className={`rounded-xl border bg-white p-3 shadow-sm sm:p-4 ${module.featured ? 'border-alert ring-2 ring-alert/30 md:col-span-2 md:order-first' : 'border-metal'}`} style={{
          borderLeft: `6px solid ${module.color}`
        }} data-id="element-181" data-mp="1bbl0ss8swtp">
              {module.featured && <p className="mb-1.5 w-fit rounded-md bg-alert px-2 py-0.5 font-display text-2xs font-extrabold uppercase tracking-wide text-white sm:text-xs" data-id="element-182" data-mp="1z6gxo2maibtk">
                  ⭐ Le module central du système
                </p>}
              <h3 className="flex items-start gap-1.5 text-sm leading-tight text-navy sm:text-base" data-id="element-183" data-mp="1l8sago4r2slc">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-184" data-mp="1g97g6r0iz8ey" />
                {module.title}
              </h3>
              <p className="mt-1 text-sm leading-snug text-steel" data-id="element-185" data-mp="3amf9ge8urbyh">{module.body}</p>
              <p className="mt-1 font-display text-xs font-bold uppercase text-tech" data-id="element-186" data-mp="35o41ya615djf">
                {module.tagline}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}